export default __webpack_public_path__ + "static/media/Logo_spintr_RGB_Blue-2.41e274f3.png";